
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { MarketStateProvider } from './contexts/MarketStateContext';
import { OverrideRefreshProvider } from './contexts/OverrideRefreshContext';
import { ChatProvider } from './contexts/ChatContext';
import Login from './pages/Login';
import Home from './pages/Home';
import Users from './pages/Users';
import MarketAssignments from './pages/MarketAssignments';
import Market from './pages/Market';
import AircraftDetail from './pages/AircraftDetail';
import TransactionDetail from './pages/TransactionDetail';
import AircraftTransactionDetail from './pages/AircraftTransactionDetail';
import EventDetail from './pages/EventDetail';
import NotesPage from './pages/NotesPage';
import MarketConfigure from './pages/MarketConfigure';
import ABB from './pages/ABB';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import GlobalChat from './components/chat/GlobalChat';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ChatProvider>
          <MarketStateProvider>
            <OverrideRefreshProvider>
              <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute>
                <AdminRoute>
                  <Users />
                </AdminRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/users/:userId/assign-markets"
            element={
              <PrivateRoute>
                <AdminRoute>
                  <MarketAssignments />
                </AdminRoute>
              </PrivateRoute>
            }
          />
          <Route
            path="/market/:modelId"
            element={
              <PrivateRoute>
                <Market />
              </PrivateRoute>
            }
          />
          <Route
            path="/market/:modelId/for-sale/:aircraftId"
            element={
              <PrivateRoute>
                <AircraftDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/market/:modelId/off-market/:aircraftId"
            element={
              <PrivateRoute>
                <AircraftDetail />
              </PrivateRoute>
            }
          />
          {/* Unified notes route - all notes access through aircraft ID */}
          <Route
            path="/market/:modelId/aircraft/:aircraftId/notes"
            element={
              <PrivateRoute>
                <NotesPage />
              </PrivateRoute>
            }
          />
          {/* Legacy routes - still supported for backward compatibility */}
          <Route
            path="/market/:modelId/for-sale/:aircraftId/notes"
            element={
              <PrivateRoute>
                <NotesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/market/:modelId/off-market/:aircraftId/notes"
            element={
              <PrivateRoute>
                <NotesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/market/:modelId/sold/:transId/notes"
            element={
              <PrivateRoute>
                <NotesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/market/:modelId/removed/:eventId/notes"
            element={
              <PrivateRoute>
                <NotesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/market/:modelId/sold/:transId"
            element={
              <PrivateRoute>
                <TransactionDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/market/:modelId/sold-snapshot/:transactionId"
            element={
              <PrivateRoute>
                <AircraftTransactionDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/market/:modelId/removed/:eventId"
            element={
              <PrivateRoute>
                <EventDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/market/:modelId/configure"
            element={
              <PrivateRoute>
                <MarketConfigure />
              </PrivateRoute>
            }
          />
          <Route
            path="/market/:modelId/configure/abb"
            element={
              <PrivateRoute>
                <ABB />
              </PrivateRoute>
            }
          />
              <Route path="*" element={<Navigate to="/" />} />
              </Routes>
              <GlobalChat />
            </OverrideRefreshProvider>
          </MarketStateProvider>
        </ChatProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
